import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { actions, selectors } from 'modules/debts';
import { selectors as userSelectors } from 'modules/user';

import DebtEditor from './DebtEditor';
import Loader from 'components/Loader';

class DebtEditorContainer extends PureComponent {
  render() {
    const { debts, loading, settings, onAdd, onRemove, onSave, onUpdate } = this.props;

    if (loading) return <Loader />;

    return (
      <DebtEditor
        debts={debts}
        settings={settings}
        onAdd={onAdd}
        onRemove={onRemove}
        onSave={onSave}
        onChange={onUpdate}
      />
    );
  }
}

const mapStateToProps = state => ({
  debts: selectors.debts(state),
  loading: selectors.loading(state),
  settings: userSelectors.settings(state),
});

export default connect(mapStateToProps, {
  onAdd: actions.addDebt,
  onRemove: actions.removeDebt,
  onSave: actions.saveDebt,
  onUpdate: actions.updateDebt,
})(DebtEditorContainer);



// WEBPACK FOOTER //
// ./src/components/DebtEditor/DebtEditor.container.js